import { render, staticRenderFns } from "./DraggableTarget.vue?vue&type=template&id=78ac869c&"
import script from "./DraggableTarget.vue?vue&type=script&lang=ts&"
export * from "./DraggableTarget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports